import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OneFormulaData } from "../components/SettingsPage/types";

interface SettingsState {
  oneFormulaDefaultDraft: OneFormulaData | null;
  oneFormulaDefaultDraftUpdatedAt?: string;
  pipelinePending: boolean;
}

const initialState: SettingsState = {
  oneFormulaDefaultDraft: null,
  oneFormulaDefaultDraftUpdatedAt: undefined,
  pipelinePending: false,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setOneFormulaDefaultDraft: (state, action: PayloadAction<OneFormulaData>) => {
      state.oneFormulaDefaultDraft = action.payload;
      state.oneFormulaDefaultDraftUpdatedAt = action.payload.lastEditTime;
    },
    clearOneFormulaDefaultDraft: (state) => {
      state.oneFormulaDefaultDraft = null;
      state.oneFormulaDefaultDraftUpdatedAt = undefined;
    },
    setPipelinePending: (state, action: PayloadAction<boolean>) => {
      state.pipelinePending = action.payload;
    },
  },
});

export const { setOneFormulaDefaultDraft, clearOneFormulaDefaultDraft, setPipelinePending } = settingsSlice.actions;
export default settingsSlice.reducer;

